import * as React from 'react';
import * as _ from 'underscore';
import * as $ from 'jquery';

import { IGlob } from '../../../../_common/application/ts/Glob';
import ClickToFilterAttributeSelect, {
    IToggleStates
} from '../../../../_common/platform/tsx/filtering/ClickToFilterAttributeSelect';

import * as Utilities from '../../../../_common/platform/ts/Utilities';
import { IAttrQuery } from '../../../../pdc-widget-grid/src/ts/components/Interfaces';
import { IPopupOptions } from '../../../../pdc-platform/src/ts/actions/DialogActions';

import { IAttribute } from '../../../../_common/platform/tsx/filtering/Interfaces';

const reactGlobalClick = require('_common/platform/ts/reactGlobalClick'); //LL: 04.09.19

require('../../../../_common/platform/sass/attribute-options-select.sass');

export interface IAttributeOptionsSelectProperties {
    value: IAttrQuery;
    dataSourceID: number;
    entitiesTree: any[];
    entityCollapsedDict?: IToggleStates;
    disableClickToFilter?: boolean;
    tabID?: number;

    onChange?(value: IAttrQuery): void;
    onEntityCollapsedDictChange?(value): void;

    glob: IGlob;
}

interface IOptionsSelectPopupOptions extends IPopupOptions {
    dataSourceID: number;
    value: IAttrQuery;
    entitiesTree: any[];
    entityCollapsedDict: IToggleStates;
    disableClickToFilter: boolean;
    tabID: number;

    onChange(value: IAttrQuery): void;
    onEntityCollapsedDictChange(value): void;
}

class OptionsSelectPopup extends React.Component<
    {
        zIndex: number;
        options: IOptionsSelectPopupOptions;

        close(): void;

        glob: IGlob;
    },
    {
        value: IAttrQuery;
        height: number;
        width: number;
        errors: string[];
    }
> {
    private references: {
        popupBody?: HTMLElement;
    } = {};

    constructor(props) {
        super(props);

        this.state = {
            value: this.getValueCopy(this.props.options.value),
            errors: [],
            height: 480,
            width: 600
        };
    }

    getValueCopy(value: IAttrQuery): IAttrQuery {
        return (value != null ? $.extend(true, {}, value) : {}) as IAttrQuery;
    }

    handleOKButtonClick = () => {
        this.props.close();

        if (typeof this.props.options.onChange === 'function') {
            const valueCopy = this.getValueCopy(this.state.value);
            this.props.options.onChange(valueCopy);
        }
    };

    processValueChange(value: IAttrQuery) {
        this.setState({ value: value });
    }

    handleClickToFilterAttributeChange = (value: IAttribute) => {
        const valueCopy = this.getValueCopy(this.state.value);

        if (value != null) {
            valueCopy.clickToFilterAttribute = value;
        } else {
            delete valueCopy.clickToFilterAttribute;
        }

        this.processValueChange(valueCopy);
    };

    private globalClickIndex = 0; //LL: 04.09.19: problem when click "Save" on Config dialog instead of this dialog

    componentDidMount() {
        this.globalClickIndex = reactGlobalClick.register(this.props.close); //LL: 04.09.19

        const dialog = this.references.popupBody;

        this.setState(
            _.extend(this.state, {
                height: dialog.clientHeight,
                width: dialog.clientWidth
            })
        );
    }

    componentWillUnmount() {
        reactGlobalClick.unregister(this.globalClickIndex);
        delete this.globalClickIndex;
    }

    render() {
        const options = this.props.options;

        const popoverStyle = Utilities.getPopoverStyle(options, {
            width: this.state.width,
            height: this.state.height
        });

        let style = {
            display: 'block',
            left: popoverStyle.left,
            top: popoverStyle.top,
            zIndex: this.props.zIndex
        };

        const value = this.state.value;

        let errors;
        if (this.state.errors.length > 0) {
            errors = <div className="text-danger">{this.state.errors.join(', ')}</div>;
        }

        return (
            <div className="attribute-options-select-dialog">
                <div
                    className={'popover attribute-options-select-popover-grid ' + popoverStyle.side}
                    style={style}
                    ref={(input) => {
                        this.references.popupBody = input;
                    }}
                >
                    <div className="arrow" style={{ top: popoverStyle.arrowTop }}></div>

                    <h3 className="popover-header">
                        {'More Options'}
                        <button type="button" className="close" onClick={this.props.close}>
                            ×
                        </button>
                    </h3>
                    <div>
                        <div className="popover-body">
                            {errors}

                            <ClickToFilterAttributeSelect
                                value={value.clickToFilterAttribute}
                                attributeName={value}
                                dataSourceID={options.dataSourceID}
                                entitiesTree={options.entitiesTree}
                                entityCollapsedDict={options.entityCollapsedDict}
                                disableByOption={options.disableClickToFilter}
                                tabID={options.tabID}
                                onChange={this.handleClickToFilterAttributeChange}
                                onEntityCollapsedDictChange={options.onEntityCollapsedDictChange}
                                glob={this.props.glob}
                            />
                        </div>
                    </div>
                    <div className="modal-footer">
                        <div className="btn btn-success button-confirm" onClick={this.handleOKButtonClick}>
                            {'OK'}
                        </div>

                        <button className="btn btn-default" onClick={this.props.close}>
                            {'Cancel'}
                        </button>
                    </div>
                </div>

                <div className="modal-backdrop fade show"></div>
            </div>
        );
    }
}

export default function AttributeOptionsSelect(props: IAttributeOptionsSelectProperties) {
    const handleOnChange = (value: IAttrQuery) => {
        if (typeof props.onChange === 'function') {
            props.onChange(value);
        }
    };

    const handleOnSelectorShow = (e) => {
        const offset = $(e.target).offset();

        props.glob.DialogActions.createPopup<IOptionsSelectPopupOptions>('custom', {
            top: offset.top,
            left: offset.left,
            dataSourceID: props.dataSourceID,
            value: props.value,
            entitiesTree: props.entitiesTree,
            entityCollapsedDict: props.entityCollapsedDict,
            disableClickToFilter: props.disableClickToFilter,
            tabID: props.tabID,

            onChange: handleOnChange,
            onEntityCollapsedDictChange: props.onEntityCollapsedDictChange,

            component: OptionsSelectPopup
        });
    };

    return (
        <div className="attribute-options-select">
            <div className="content">
                <span className="glyphicon glyphicon-cog" onClick={handleOnSelectorShow}></span>

                <span className="value" title={''}>
                    <em className="empty" onClick={handleOnSelectorShow}></em>
                </span>
            </div>
        </div>
    );
}
